export default "__VITE_ASSET__CUyKUK7t__"